export { default as PortalElement } from './PortalElement';
export { default as Portal } from './Portal';

export const PortalNamespace = 'portal-root';
